/***
*
*   ACCOUNT NAV
*   Acount sub nav that renders different options based
*   on user permissions. Shows billing & user admin to only account owners
*
**********/

import React from 'react';
import { SubNav } from 'components/lib';

export function AccountNav(props){

  return(
    <SubNav items={[

      { link: '/account/profile', label: 'Perfil' },
      { link: '/account/password', label: 'Contraseña' },
      { link: '/account/2fa', label : 'Factor de doble autentificación' },
      //{ link: '/account/billing', label: 'Facturación', permission: 'owner' },
      { link: '/account/apikeys/', label: 'Claves de API', permission: 'developer' },
      { link: '/account/users', label: 'Usuarios', permission: 'admin' }

    ]}/>
  );
}
